/* RH_PAIRS_WELL_WITH_COMPACT_V1 */
if (typeof complementaryProductsComponent === 'undefined')
{   
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }


        bindDirectAtc(root) {
            /* RH_PAIRS_WELL_WITH_DIRECT_ATC_JS_V1 */
            if (!root) return;
            root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
                if (form.dataset.rhPairsAtc === '1') return;
                form.dataset.rhPairsAtc = '1';
                const idInput = form.querySelector('input[name="id"]');
                if (idInput) {
                    idInput.disabled = false;
                    idInput.removeAttribute('disabled');
                }
                const button = form.querySelector('[type="submit"]');
                if (button) {
                    button.setAttribute('data-btn-addToCart', '');
                    button.setAttribute('aria-haspopup', 'false');
                }
                form.addEventListener('submit', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    const id = idInput && idInput.value;
                    if (!id) return;
                    if (button) button.classList.add('is-loading');
                    const $btn = window.jQuery ? window.jQuery(button) : button;
                    if (window.Shopify && typeof Shopify.addItem === 'function') {
                        Shopify.addItem(id, 1, $btn);
                        return;
                    }
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                        body: JSON.stringify({ id: Number(id), quantity: 1 })
                    }).then((res) => res.json()).then(() => {
                        window.location.href = '/cart';
                    }).finally(() => {
                        if (button) button.classList.remove('is-loading');
                    });
                });
            });
        }

        connectedCallback() {
            /* RH_PAIRS_WELL_WITH_SSR_JS_V1 */
            if (this.classList.contains('rh-pairs-ssr') || this.querySelector('.card-wrapper, .product')) {
                const productCarousel = this.querySelector('.products-carousel');
                if (productCarousel) productCarousel.classList.add('rh-pairs-stack');
                this.bindDirectAtc(this);
                return;
            }
            const url = this.dataset.url;
            this.buildProducts(url);
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();
                    
                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div').replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('[data-complementary-product]');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                    this.bindDirectAtc(this);
    
                    if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }
                    
                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);
            }
    
            fetchProducts(url);
        }
        
        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = parseInt(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1') ? true : false;

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                const slideCount = productCarousel.querySelectorAll(':scope > .product, :scope > .slick-list .product').length || productCarousel.children.length;
                const safeRows = complementaryStyle ? 1 : Math.max(1, Math.min(Number(itemRows) || 1, Number(slideCount) || 1));
                const canLoop = complementaryStyle ? slideCount > Number(itemToShow || 1) : slideCount > safeRows;
                if(complementaryStyle) {
                    /* RH_PAIRS_WELL_WITH_STACK_JS_V1 */
                    productCarousel.classList.add('rh-pairs-stack');
                } else if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: itemDots && canLoop,
                        arrows: itemArrows && canLoop,
                        slidesToShow: complementaryStyle ? itemToShow : 1,
                        rows: safeRows,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                        infinite: canLoop,
                        rtl: window.rtl_slick,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    get slidesToShow() {
                                        if (complementaryStyle) {
                                            slidesToShow: 2
                                        }
                                        if (!complementaryStyle) {
                                            slidesToShow: 1
                                        }
                                    }
                                }
                            },
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            }
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    })

    var complementaryProductsComponent = ComplementaryProductsComponent;
}